import { useCallback, useState } from 'react';

export const useDatesChange = (initialValue: boolean) => {
  const [isDatesSet, setDatesSet] = useState<boolean>(initialValue);
  const onDatesSet = useCallback((start: string | undefined, end: string | undefined) => {
    setDatesSet(Boolean(start) || Boolean(end));
  }, []);
  return { isDatesSet, onDatesSet };
};
